import Head from 'next/head'
import { FB_APP_ID } from '../../lib/Utils'
import { SEOData } from '../../types/Common'

const title =
  'Search Local, Regional & OTR Truck Driving Jobs | Driversjobchoice.com'
const description =
  'Search High Paying, Local, Regional & OTR Truck Driver Jobs. Your Job, Your Choice! Drivers Job Choice.'
const JobsListHead = ({ domain, currentUrl }: SEOData) => {
  return (
    <Head>
      <title>{title}</title>

      <meta name="twitter:card" content="summary" key="twitterCard"></meta>
      <meta property="og:url" content={currentUrl} key="ogUrl"></meta>
      <meta property="og:title" content={title} key="ogTitle" />

      <meta name="description" content={description} key="description"></meta>
      <meta
        property="og:description"
        content={description}
        key="ogDescription"></meta>
      <meta
        property="og:image"
        content={`${domain}/assets/img/company/default.webp`}
        key="ogImage"></meta>

      <meta property="og:type" content="website" key="ogType"></meta>
      <meta property="fb:app_id" content={FB_APP_ID} key="fbAppId"></meta>
      <meta
        property="keywords"
        content="ttruck driving jobs, truck driver jobs, driver jobs, driving jobs, cdl jobs, owner operator jobs, trucking, trucking jobs, local driver jobs, OTR driver jobs, trucks, carriers, trucking companies, truck carriers"
        key="keywords"></meta>
    </Head>
  )
}

export default JobsListHead
